import { render } from "./ReponsesCandidatsElections.vue?vue&type=template&id=c67d747a&scoped=true&ts=true"
import script from "./ReponsesCandidatsElections.vue?vue&type=script&lang=ts"
export * from "./ReponsesCandidatsElections.vue?vue&type=script&lang=ts"

import "./ReponsesCandidatsElections.vue?vue&type=style&index=0&id=c67d747a&scoped=true&lang=css"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67d747a"]])

export default __exports__